



















































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { randomId } from '@/helpers';
import SelectField from '@/components/forms/fields/common/SelectField.vue';
import Multiselect from 'vue-multiselect';
import EntityAddress from '@/zenky/interfaces/common/addresses/EntityAddress';
import City from '@/zenky/interfaces/store/City';
import Stock from '@/zenky/interfaces/store/Stock';
import { OrderV3 } from '@/zenky/interfaces/orders/Order';
import store from '@/store/index';
import FormFieldOption from '@/zenky/forms/interfaces/FormFieldOption';
import axios from '@/zenky/api/Http';
import { SuggestionRequest } from '@/zenky/interfaces/common/addresses/suggestions';
import { Omit } from 'lodash';
import { assertNever } from '@/helpers/utils';
import DatetimePicker from '@/components/forms/fields/DatetimePicker.vue';
import { Russian } from 'flatpickr/dist/l10n/ru';
import * as VeeValidate from 'vee-validate';

type DeliveryMethod = 'courier' | 'pickup'; // | 'delivery-service'

type PickedEntityAddress = Pick<EntityAddress, 'house' | 'apartment' | 'entrance' | 'floor' | 'has_intercom'
  | 'street'>;
interface DeliveryInfoBase extends PickedEntityAddress {
  method: DeliveryMethod;
  city: Pick<Exclude<OrderV3['city'], undefined | null>, 'id' | 'name'> | null;
  stock: Pick<Exclude<OrderV3['stock'], undefined | null>, 'id' | 'name'> |null;
  // price: number;
}

interface CourierDeliveryInfo extends DeliveryInfoBase {
  // deliveryArea:
  // `null` = ASAP, `undefined` = at specific time, which hasn't been selected yet.
  deliverAt: null | undefined | string;
  // delivery timing
}
interface PickupDeliveryInfo extends Pick<DeliveryInfoBase, 'city' | 'stock'> {}
// interface DeliveryServiceDeliverySpecificInfo {
//   country: ;
//   region: ;
//   deliveryService: ;
//   trackNo
// }

// Yes, it's intersection, not union. We don't want data to be reset each when the user switches between delivery types.
// And yes, this may be a bad decision.
type DeliveryInfo = CourierDeliveryInfo & PickupDeliveryInfo; // & DeliveryServiceDeliverySpecificInfo

export type ChangeEvent = [
  DeliverySection['value'], // New value
  keyof DeliverySection['value'], // What changed
];

VeeValidate.extend('streetRequired', {
  validate(value: DeliverySection['streetSelectValue']) {
    if (value.value === null) {
      return 'Обязательно';
    }
    return true;
  },
});

@Component({ components: { SelectField, Multiselect, DatetimePicker } })
export default class DeliverySection extends Vue {
  @Prop({ required: true, type: Object }) readonly value!: DeliveryInfo;
  stocksLoading: boolean = false;
  citiesLoading: boolean = false;
  requestDeboundeTimeoutId: number | -1 = -1;
  streetSearchTerm: string = '';
  streetOptions: FormFieldOption[] = [];
  streetSuggestionsLoading: boolean = false;
  private readonly sectionUid = randomId('order-delivery-section');
  private readonly randomId = randomId;
  private readonly deliveryMethods: { label: string, techName: DeliveryMethod }[] = [
    { label: 'Доставка курьером', techName: 'courier' },
    { label: 'Самовывоз', techName: 'pickup' },
    // { label: 'Службой доставки', techName: 'delivery-service' },
  ]
  private readonly houseToApartmentFields: { label: string, techName: keyof DeliveryInfo }[] = [
    { label: 'Дом', techName: 'house' },
    { label: 'Квартира', techName: 'apartment' },
    { label: 'Подъезд', techName: 'entrance' },
    { label: 'Этаж', techName: 'floor' },
  ]
  private readonly flatpickrConfig = {
    static: true,
    enableTime: true,
    locale: Russian,
    dateFormat: 'Y-m-d H:i', // As in SubmitOrder['deliver_at']. Thogh it's like this by default.
  };

  created() {
    if (store.state.helpers.stocks.loaded === false) {
      this.stocksLoading = true;
      store.dispatch('helpers/initStocks').finally(() => {
        this.stocksLoading = false;
      });
    }
    if (store.state.helpers.storeCities === null) {
      this.citiesLoading = true;
      store.dispatch('helpers/loadStoreCities').finally(() => {
        this.citiesLoading = false;
      });
    }
  }
  change<T extends keyof DeliverySection['value']>(key: T, newVal: DeliverySection['value'][T]) {
    const payload: ChangeEvent = [
      {
        ...this.value,
        [key]: newVal,
      },
      key,
    ];
    this.$emit('change', ...payload);
  }

  get stocks(): Stock[] | null {
    return store.state.helpers.stocks.loaded ? store.state.helpers.stocks.items : null;
  }
  get stockOptions(): FormFieldOption[] {
    if (this.stocks === null) {
      if (this.value.stock === null) {
        return [];
      }
      return [{ value: this.value.stock.id, label: this.value.stock.name }];
    }
    return this.stocks.map(stock => ({ value: stock.id, label: stock.name }));
  }
  onStockChange(stockId: string) {
    if (this.stocks === null) {
      throw new Error('Selected a stock while stocks list is not loaded');
    }
    const matchedStock = this.stocks.find(stock => stock.id === stockId);
    if (matchedStock === undefined) throw new Error('Selected stock not found in the stock list');
    this.change('stock', matchedStock);
  }

  get cities(): City[] | null {
    return store.state.helpers.storeCities;
  }
  get cityOptions(): FormFieldOption[] {
    if (this.cities === null) {
      if (this.value.city === null) {
        return [];
      }
      return [{ value: this.value.city.id, label: this.value.city.name }];
    }
    return this.cities.map(city => ({ value: city.id, label: city.name }));
  }
  onCityChange(cityId: string) {
    if (this.cities === null) throw new Error('Selected a city while cities list is not loaded');
    const matchedCity = this.cities.find(city => city.id === cityId);
    if (matchedCity === undefined) throw new Error('Selected city not found in the cities list');
    this.change('city', matchedCity);
  }

  onStreetInput(newVal: string) {
    this.streetSearchTerm = newVal;
    clearTimeout(this.requestDeboundeTimeoutId);
    // TODO cancel request
    this.requestDeboundeTimeoutId = -1;
    if (!this.termTooShort) {
      this.requestDeboundeTimeoutId = setTimeout(() => {
        this.loadStreetSuggestions(this.streetSearchTerm);
        this.requestDeboundeTimeoutId = -1;
      }, 250);
    } else {
      this.streetOptions = [];
    }
  }
  get termTooShort(): boolean {
    return this.streetSearchTerm.length <= 1;
  }
  async loadStreetSuggestions(term: string) {
    this.streetSuggestionsLoading = true;
    if (this.value.city === null) throw new Error('City must be specified in order to load street sugestions');
    const payload: SuggestionRequest = {
      query: term,
      count: 5,
      to_bound: { value: 'street' },
      from_bound: { value: 'street' },
      locations: [{ city: this.value.city.name }],
      restrict_value: true,
    };
    const request = axios.post('suggestions/addresses/suggest/address', payload);
    this.streetOptions = ((await request).data.suggestions as any[]).map(
      suggestion => ({ label: suggestion.value, value: suggestion.data.street_with_type }),
    );
    this.streetSuggestionsLoading = false;
  }
  get streetSelectValue() {
    return { value: this.value.street, label: this.value.street === null ? null : this.value.street };
  }

  get deliveryTimingType() {
    return this.value.deliverAt === null ? 'asap' : 'at';
  }
  get deliveryTimingTypeOptions(): (FormFieldOption & { value: DeliverySection['deliveryTimingType'] })[] {
    return [
      { label: 'Как можно скорее', value: 'asap' },
      { label: 'Ко времени', value: 'at' },
    ];
  }
  onDeliveryTimingTypeSelect(event: this['deliveryTimingTypeOptions'][number]) {
    switch (event.value) {
      case 'asap': this.change('deliverAt', null); break;
      case 'at': {
        this.change('deliverAt', undefined);
        break;
      }
      default: assertNever(event.value);
    }
  }
  onDeliveryTimeInputChange(selectedDates: Date[], dateStr: string) {
    if (this.deliveryTimingType !== 'at') {
      // A workaround for this scenario (or likes of it):
      // 1. New order.
      // 2. Change delivery timing type to `'at'`
      // 3. Select date.
      // 4. Change delivery timing type back to `'asap'`.
      // It didn't change, becaure `deliverAt` changed to `''` thanks to Flatpickr.
      return;
    }
    this.change('deliverAt', dateStr);
  }
}
